import styled from 'styled-components'

const DarkBackground = styled.div`
  width: 100%;
  height: 100%;
  background: ${props => props.theme.palette.neutral.control.black100};
`

interface Props {
  background: App.SiteTakeoverBackground
  className?: string
  placement?: App.SiteTakeoverPlacement
}

function TasteOfGoldBackground(props: Props) {
  const { className } = props

  return <DarkBackground className={className} />
}

export default TasteOfGoldBackground
